import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { useCart } from "../../context/CartContext";

import {
  Swiper,
  SwiperSlide,
  Autoplay,
  Pagination,
} from "../homepage/Shared/CustomSwiper";
import { Heart, ShoppingBag } from "lucide-react";
import { showError } from "../../utils/toastUtils";
import Auth from "../../utils/AuthUtils";
import wishlistAPI from "../../api/wishlistApi";

function Card({ item }) {
  const { addToCart } = useCart();
  const navigate = useNavigate();

  const { config } = useSiteConfig();

  const initialPrice =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.price ?? 0)
      : (item?.price ?? 0);

  const initialMrp =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.mrp ?? 0)
      : (item?.mrp ?? 0);

  const initialDiscount =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.discount ?? 0)
      : (item?.discount ?? 0);

  const initialStock =
    item?.productType === "Variant"
      ? (item?.variants?.[0]?.stock ?? 0)
      : (item?.stock ?? 0);

  const [image, setImage] = useState(item?.thumbnail);
  const [slug, setSlug] = useState(item?.slug);
  const [title, setTitle] = useState(item?.title);

  const [activePrice, setActivePrice] = useState(initialPrice);
  const [activeMrp, setActiveMrp] = useState(initialMrp);
  const [activeDiscount, setActiveDiscount] = useState(initialDiscount);
  const [activeStock, setActiveStock] = useState(initialStock);
  const [shortDescription, setShortDescription] = useState(
    item?.shortDescription,
  );
  const [activeVariantId, setActiveVariantId] = useState(
    item?.productType === "Variant" && item?.variants?.length
      ? item?.variants[0]._id
      : null,
  );
  const [isWishlisted, setIsWishlisted] = useState(item.isWishlisted || false);

  const galleryImages = [item?.thumbnail, ...(item?.gallery || [])].filter(
    Boolean,
  );

  // Update price & image when variant changes
  useEffect(() => {
    if (item?.productType !== "Variant") return;
    const selected = item?.variants?.find((v) => v._id === activeVariantId);
    if (selected) {
      const newImg = selected.images?.[0] || item?.thumbnail;
      setImage(newImg);
      setActivePrice(selected.price);
      setActiveMrp(selected.mrp);
      setActiveDiscount(selected.discount);
      setActiveStock(selected.stock);
    }
  }, [activeVariantId, item]);

  const hasDiscount =
    activeDiscount !== null && activeDiscount > 0 && activeMrp > activePrice;

  const handleAddToCart = (e) => {
    const action = e.currentTarget.getAttribute("data-action");

    try {
      addToCart(item?._id, 1, activeVariantId || "");

      if (action === "buy-now") {
        navigate("/checkout");
      }
    } catch (err) {
      console.error("Add to cart error:", err);
    }
  };

  const handleWishlistToggle = async (e) => {
    e.preventDefault();

    const isLoggedIn = Auth.getToken();

    if (!isLoggedIn) {
      showError("Please log in to manage your wishlist");
      return;
    }

    try {
      const res = await wishlistAPI.addProduct({ productId: item?._id });
      if (res.code === 200) {
        setIsWishlisted((prev) => !prev);
      }
    } catch (error) {
      showError("Failed to update wishlist");
    }
  };

  const isOutOfStock = activeStock <= 0;

  return (
    <>
      <div className="custom-product-card" style={{ cursor: "pointer" }}>
        {/* Image Wrapper */}
        <div className="custom-product-img-wrapper">
          {hasDiscount && (
            <span className="custom-product-tag">
              {Math.round(activeDiscount)}% OFF
            </span>
          )}
          <button
            className={`custom-product-wishlist wishlist-btn ${isWishlisted ? "active" : ""}`}
            onClick={handleWishlistToggle}
            aria-label="Add to wishlist"
          >
            <Heart
              size={18}
              className="custom-product-icon"
              strokeWidth={isWishlisted ? 0 : 1.5}
            />
          </button>
          <Link to={`/shop/${slug}`} className="custom-product-img">
            <img src={image} alt={title} />
          </Link>

          {isOutOfStock && (
            <p className="text-danger fw-bold mt-1">Out of Stock</p>
          )}

         
        </div>

        {/* Content */}
        <div className="custom-product-info">
          <div className="d-flex justify-content-between align-items-start mb-1">
            <Link to={`/shop/${slug}`} className="custom-product-name text-decoration-none">{title}</Link>
          </div>

          <p className="custom-product-desc text-muted small">
            {shortDescription}
          </p>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <div className="d-flex align-items-center ">
              <p className="custom-product-price mb-0">₹{activePrice}</p>
              <p className="custom-product-price-del ms-2 mb-0">₹{activeMrp}</p>
            </div>

            {!isOutOfStock && config?.productVisibility === "cart" && (
              <>
                {/* <button
                  className="custom-product-cart-btn"
                  data-id={item?._id}
                  data-price={activePrice}
                  data-variant={activeVariantId || ""}
                  data-quantity={1}
                  data-action="cart"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#shoppingCartCanvas"
                  onClick={handleAddToCart}
                >
                Buy Now
                  <ShoppingBag size={18} />
                </button> */}
                <Link to={`/shop/${slug}`} className="buy-now-btn"> 
                  Buy Now
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Card;
